module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_Sand.524920a1.png";